import { AttachmentsCellEditor, AttachmentsCellRenderer } from './AttachmentsCellInnerComponents'
import { DataGridCell } from './types'

export const AttachmentsCell: DataGridCell = {
    provideRenderer: AttachmentsCellRenderer,
    provideEditor: AttachmentsCellEditor,
    popupEditor: true,
}
